const o = "div";
export {
  o as cardFooterDefaultAs
};
